import 'slick-carousel';

export default {
  init() {
    var $header = $('.htheme-header--slider');
    var $headerslides = $($header.find('.htheme-header__slides').first());
    $headerslides.slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $($header.find('.wmtm-prev')),
      nextArrow: $($header.find('.wmtm-next')),
      customPaging: function() {
        return '<div class="dot"></div>';
      },
      slides: '.htheme-slider__slide',
    })
  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/header/slider.js